import React from 'react';
import { Link } from 'react-router-dom';
import chandraLogo from '../gallery_main/chandra_industries/chandra_industries_logo.webp';
import instagramIcon from '../gallery_main/vcs-instagram.webp';
import facebookIcon from '../gallery_main/vcs-facebook.webp';
import siteConfig from '../siteConfig';
import '../styles/_global.css';

const Footer = () => {
  return (
    <footer>
      <div className="footer-top">
        <div className="footer-social">
          <span className="footer-find-us">Find us at:</span>
          <a
            href={siteConfig.social.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-link"
          >
            <img
              loading="lazy"
              src={instagramIcon}
              alt="Instagram"
              className="footer-social-icon"
            />
          </a>
          <a
            href={siteConfig.social.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-link"
          >
            <img
              loading="lazy"
              src={facebookIcon}
              alt="Facebook"
              className="footer-social-icon"
            />
          </a>
        </div>
        <div className="developer-tag">
          <p>
            Powered by{' '}
            <a
            href="https://chandraindustries.org"
            target="_blank"
            rel="noopener noreferrer"
            >
              <img
                loading="lazy"
                src={chandraLogo}
                alt="Chandra Industries Logo"
              />
            </a>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <span className="footer-copyright">
          &copy; {new Date().getFullYear()} {siteConfig.siteName}
        </span>
        <Link to="/legal" className="footer-legal-link">
          Terms &amp; Conditions
        </Link>
      </div>
    </footer>
  );
};

export default Footer;